import { Observable } from 'rxjs';

/** 表示具有指定开始和结束的数字范围。 */
export interface ListRange {
  start: number;
  end: number;
}

/**
 * 接口，用于提供某些数据收集的视图并希望提供有关视图和所做更改的信息的任何组件。
 */
export interface CollectionViewer {
  /**
   * 每当“CollectionViewer”开始查看数据的新部分时发出的流。“开始”索引具有包容性，而“结束”索引具有排他性。
   */
  viewChange: Observable<ListRange>;
}

export interface SimDataSource<T> {
  connect(collectionViewer: CollectionViewer): Observable<T[] | ReadonlyArray<T>>;

  disconnect(collectionViewer: CollectionViewer): void;
}

/** 检查对象是否为数据源 */
export function isDataSource(value: any): value is SimDataSource<any> {
  // 通过观察该值是否有连接函数来检查该值是否为数据源。不能作为一个“instanceof DataSource”检查，因为人们可以创建自己的匹配接口的源，但不扩展数据源。
  return value && typeof value.connect === 'function';
}
